/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Help_TextInputs */

const en_portalsignin_help_text = /** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouble signing in?`)
};

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const ar_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const he_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const ur_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const es_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const fr_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const de_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const pt_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const hi_portalsignin_help_text = en_portalsignin_help_text;

/** @type {(inputs: Portalsignin_Help_TextInputs) => LocalizedString} */
const bn_portalsignin_help_text = en_portalsignin_help_text;

/**
* | output |
* | --- |
* | "Trouble signing in?" |
*
* @param {Portalsignin_Help_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_help_text = /** @type {((inputs?: Portalsignin_Help_TextInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Help_TextInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_help_text(inputs)
	if (locale === "he") return he_portalsignin_help_text(inputs)
	if (locale === "ur") return ur_portalsignin_help_text(inputs)
	if (locale === "es") return es_portalsignin_help_text(inputs)
	if (locale === "fr") return fr_portalsignin_help_text(inputs)
	if (locale === "de") return de_portalsignin_help_text(inputs)
	if (locale === "pt") return pt_portalsignin_help_text(inputs)
	if (locale === "hi") return hi_portalsignin_help_text(inputs)
	if (locale === "bn") return bn_portalsignin_help_text(inputs)
	return /** @type {LocalizedString} */ ("Trouble signing in?")
});